import { isEqual } from 'lodash';
import React from 'react';
import { ColumnComponentInterface, ComponentStylingInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

const ColumnStyling = ({ component, onChange }: ComponentStylingInterface<ColumnComponentInterface>) => {
  const settingSections: PageBuilderSettingsSection[] = [];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} showTitleAndDescription={false} />;
};
export default React.memo(ColumnStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
